import React from 'react';
import styled from 'styled-components';

import _Advocacy from './../../Resources/Industries/Resting/img-industry-advocacy.svg'; 
import _Education  from './../../Resources/Industries/Resting/img-industry-education.svg';
import _Events  from './../../Resources/Industries/Resting/img-industry-events.svg';
import _Healthcare  from './../../Resources/Industries/Resting/img-industry-healthcare.svg';
import _Hospitality  from './../../Resources/Industries/Resting/img-industry-hospitality.svg';
import _Other  from './../../Resources/Industries/Resting/img-industry-other.svg';
import _Retail from './../../Resources/Industries/Resting/img-industry-retail.svg';
import _SmartWorkplace  from './../../Resources/Industries/Resting/img-industry-smart-workplace.svg';


import _AdvocacySelected  from './../../Resources/Industries/Selected/img_selected-industry-advocacy.svg';
import _EducationSelected  from './../../Resources/Industries/Selected/img_selected-industry-education.svg';
import _EventsSelected  from './../../Resources/Industries/Selected/img_selected-industry-events.svg';
import _HealthcareSelected  from './../../Resources/Industries/Selected/img_selected-industry-healthcare.svg';
import _HospitalitySelected  from './../../Resources/Industries/Selected/img_selected-industry-hospitality.svg';
import _OtherSelected  from './../../Resources/Industries/Selected/img_selected-industry-other.svg';
import _RetailSelected  from './../../Resources/Industries/Selected/img_selected-industry-retail.svg';
import _SmartWorkplaceSelected from './../../Resources/Industries/Selected/img_selected-industry-smart-workplace.svg';


const Button = styled.div`
    display: block;
    height: 180px;
    width: 180px;
    cursor: pointer;
`;

const Advocacy = styled(Button)`
    background-image: url(${_Advocacy});
`;

const Education = styled(Button)`
    background-image: url(${_Education});
`;

const Events = styled(Button)`
    background-image: url(${_Events});
`;

const Healthcare = styled(Button)`
    background-image: url(${_Healthcare});
`;

const Hospitality = styled(Button)`
    background-image: url(${_Hospitality});
`;

const Other = styled(Button)`
    background-image: url(${_Other});
`;
const Retail = styled(Button)`
    background-image: url(${_Retail});
`;
const SmartWorkplace = styled(Button)`
    background-image: url(${_SmartWorkplace});
`;

const AdvocacySelected = styled(Button)`
    background-image: url(${_AdvocacySelected});
`;

const EducationSelected = styled(Button)`
    background-image: url(${_EducationSelected});
`;

const EventsSelected = styled(Button)`
    background-image: url(${_EventsSelected});
`;

const HealthcareSelected = styled(Button)`
    background-image: url(${_HealthcareSelected});
`;

const HospitalitySelected = styled(Button)`
    background-image: url(${_HospitalitySelected});
`;

const OtherSelected = styled(Button)`
    background-image: url(${_OtherSelected});
`;
const RetailSelected = styled(Button)`
    background-image: url(${_RetailSelected});
`;
const SmartWorkplaceSelected = styled(Button)`
    background-image: url(${_SmartWorkplaceSelected});
`;


export const Industries = [
    {
        id: 'Advocacy', 
        resting: (props) => <Advocacy {...props} />, 
        selected: (props) => <AdvocacySelected {...props} />, 
    },
    {
        id: 'Campus', 
        resting: (props) => <Education {...props} />, 
        selected: (props) => <EducationSelected {...props} />,
    },
    {
        id: 'Events', 
        resting: (props) => <Events {...props} />, 
        selected: (props) => <EventsSelected {...props} />,
    },
    {
        id: 'Healthcare', 
        resting: (props) => <Healthcare {...props} />, 
        selected: (props) => <HealthcareSelected {...props} />, 
    },
    {
        id: 'Hospitality', 
        resting: (props) => <Hospitality {...props} />, 
        selected: (props) => <HospitalitySelected {...props} />, 
    },
    {
        id: 'Retail',
        resting: (props) => <Retail {...props} />,
        selected: (props) => <RetailSelected {...props} />,
    },
    {
        id: 'Workplace',
        resting: (props) => <SmartWorkplace {...props} />, 
        selected: (props) =>  <SmartWorkplaceSelected {...props} />,
    },
    {
        id: 'Other',
        resting: (props) => <Other {...props} />, 
        selected: (props) => <OtherSelected {...props} />,
        theme: 'dark',
    },
];

export {Button as StylableIndustryButton};